<template>
  <v-app>
    <v-app-bar app color="#FFE0B2">
      <div class="d-flex align-center">
        <v-img
          class="shrink mr-2"
          contain
          src="./assets/RMS2050_logo_color.png"
          transition="scale-transition"
          width="110"
        />
        <h1 :style="$vuetify.breakpoint.xs ? headerStyleMobile : headerStyle">
          {{ $t(`message.headerText`) }}
        </h1>
      </div>
    </v-app-bar>

    <v-content>
      <router-view></router-view>
    </v-content>
    <Footer />
  </v-app>
</template>

<script>
import Footer from "./components/Footer";

export default {
  name: "App",
  data() {
    return {
      headerStyle: {
        color: "#000"
      },
      headerStyleMobile: {
        color: "#000",
        "font-size": "1em"
      }
    };
  },
  components: {
    Footer
  }
};
</script>
